import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/app/web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { QuestionCircleOutlined } from '@ant-design/icons';
import { Avatar, Button, Comment, Form, Input, message, Popconfirm, Tooltip } from 'antd';
import { NotificationType } from 'core/client';
import { Colors } from 'core/interfaces/variables.types';
import { getMediaStore } from 'core/modules/media/media.store';
import { getNotificationStore } from 'core/modules/notifications/notification.store';
import { getTaskStore } from 'core/modules/tasks/task.store';
import { getUserStore } from 'core/modules/users/user.store';
import moment from 'moment';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { classes } from 'src/utils/classes';
import styled from 'styled-components';
import { formHasErrors } from '../../utils/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** This component shows all the comments attached to a given task */
export var TaskComments = function TaskComments(_ref) {
  var task = _ref.task;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getMediaStore = getMediaStore(),
      media = _getMediaStore.media,
      getUserMediaSrc = _getMediaStore.getUserMediaSrc;

  var _getUserStore = getUserStore(),
      currentUser = _getUserStore.currentUser,
      getUserById = _getUserStore.getUserById;

  var _getTaskStore = getTaskStore(),
      isLoadingKey = _getTaskStore.isLoadingKey,
      addTaskComment = _getTaskStore.addTaskComment,
      deleteTaskComment = _getTaskStore.deleteTaskComment;

  var _getNotificationStore = getNotificationStore(),
      activeNotification = _getNotificationStore.activeNotification;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var highlightedCommentId = useMemo(function () {
    if ((activeNotification === null || activeNotification === void 0 ? void 0 : activeNotification.content.type) !== NotificationType.TaskCommentAdded) {
      return;
    }

    return activeNotification.content.comment;
  }, [activeNotification]);
  var comments = useMemo(function () {
    return task.comments.map(function (comment) {
      return _objectSpread(_objectSpread({}, comment), {}, {
        author: getUserById(comment.authorId),
        formattedDate: moment(comment.createdAt).format('DD/MM/YYY HH:mm'),
        fromNow: moment(comment.createdAt).fromNow()
      });
    });
  }, [task.comments]);

  function onSubmit() {
    return _onSubmit.apply(this, arguments);
  }

  function _onSubmit() {
    _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var comment;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              comment = form.getFieldValue('comment');
              _context.prev = 1;
              _context.next = 4;
              return addTaskComment(task.id, comment);

            case 4:
              message.success(t('tasks.newComment'));
              form.resetFields();
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              message.error(t('unknownError'));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));
    return _onSubmit.apply(this, arguments);
  }

  return useMemo(function () {
    return /*#__PURE__*/_jsxs(Container, {
      form: form,
      name: "comment",
      children: [comments.map(function (comment) {
        var _comment$author, _comment$author2;

        return /*#__PURE__*/_jsx("div", {
          id: "comment-".concat(comment.id),
          children: /*#__PURE__*/_jsx(Comment, {
            author: (_comment$author = comment.author) === null || _comment$author === void 0 ? void 0 : _comment$author.name,
            avatar: /*#__PURE__*/_jsx(Avatar, {
              src: getUserMediaSrc(comment.authorId),
              alt: (_comment$author2 = comment.author) === null || _comment$author2 === void 0 ? void 0 : _comment$author2.name
            }),
            content: /*#__PURE__*/_jsx("p", {
              children: comment.text
            }),
            className: classes({
              highlighted: comment.id === highlightedCommentId
            }),
            datetime: /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(Tooltip, {
                title: comment.formattedDate,
                children: /*#__PURE__*/_jsx("span", {
                  children: comment.fromNow
                })
              }), comment.authorId === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) && /*#__PURE__*/_jsx(Popconfirm, {
                getPopupContainer: function getPopupContainer(trigger) {
                  return trigger.parentElement;
                },
                title: t('areYouSure'),
                icon: /*#__PURE__*/_jsx(QuestionCircleOutlined, {
                  style: {
                    color: 'red'
                  }
                }),
                okText: t('yes'),
                cancelText: t('cancel'),
                onConfirm: function onConfirm() {
                  return deleteTaskComment(task.id, comment.id)["catch"](function () {
                    message.error(t('unknownError'));
                  });
                },
                children: /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  className: "remove-button",
                  children: t('delete')
                })
              }, "remove")]
            })
          })
        }, comment.id);
      }), /*#__PURE__*/_jsx(Comment, {
        avatar: /*#__PURE__*/_jsx(Avatar, {
          src: getUserMediaSrc(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id),
          alt: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name
        }),
        content: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Form.Item, {
            name: "comment",
            rules: [{
              required: true,
              message: t('task.comments.text.error.required')
            }],
            children: /*#__PURE__*/_jsx(Input.TextArea, {
              rows: 4,
              disabled: isLoadingKey(task.id),
              placeholder: t('task.comments.text.placeholder'),
              autoSize: {
                minRows: 3
              }
            })
          }), /*#__PURE__*/_jsx(Form.Item, {
            shouldUpdate: true,
            children: function children(form) {
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                onClick: onSubmit,
                loading: isLoadingKey(task.id),
                disabled: !form.getFieldValue('comment') || formHasErrors(form),
                children: t('task.comments.add')
              });
            }
          })]
        })
      })]
    });
  }, [comments, isLoadingKey(task.id), media]);
}; // Styles

var Container = styled(Form).withConfig({
  displayName: "Comments__Container",
  componentId: "sc-fqw29g-0"
})([".ant-comment-content-author{align-items:center;.ant-comment-content-author-time{display:block;.ant-btn{line-height:5px;height:auto;font-size:12px;padding-top:0;padding-bottom:0;}}}.ant-comment{margin-left:-16px;margin-right:-16px;padding-left:16px;padding-right:16px;&.highlighted{background-color:", ";color:", ";.ant-comment-content-author *{color:", " !important;}}}"], Colors.lightestPrimary, Colors.primary, Colors.lightPrimary);